/**
 * MediumGrid — Step 0: 2×3 grid of medium selection buttons.
 * Auto-advances on tap after 180ms visual feedback delay.
 */

import { T } from '@/styles/tokens';
import { MEDIUM_KEYS, MEDIUMS } from '@/types/medium';
import type { MediumKey } from '@/types/medium';
import { MEDIUM_ICONS } from './MediumIcons';

interface MediumGridProps {
  selected: MediumKey;
  onSelect: (medium: MediumKey) => void;
}

export function MediumGrid({ selected, onSelect }: MediumGridProps) {
  return (
    <div>
      <div style={{ marginBottom: 20, padding: '0 4px' }}>
        <div style={{ fontSize: 15, fontWeight: 500, color: T.charcoal400, lineHeight: 1.5, fontFamily: T.fontFamily }}>
          What are you pricing?
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        {MEDIUM_KEYS.map((key) => {
          const sel = key === selected;
          const config = MEDIUMS[key];
          const iconKey = key === 'mixed_media' ? 'mixed_media' : key;
          const iconFn = MEDIUM_ICONS[iconKey];

          return (
            <button
              key={key}
              onClick={() => onSelect(key)}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 10,
                padding: '20px 12px',
                borderRadius: 16,
                border: `1.5px solid ${sel ? T.primary : T.border}`,
                background: sel ? T.tealSoft : T.white,
                cursor: 'pointer',
                transition: 'all 0.15s ease',
                boxShadow: sel ? `0 2px 12px ${T.primaryGlow}` : '0 1px 2px rgba(0,0,0,0.04)',
                fontFamily: T.fontFamily,
                minHeight: 100,
              }}
            >
              <div style={{
                width: 48,
                height: 48,
                borderRadius: 14,
                background: sel ? `${T.primary}15` : T.cream,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.15s ease',
              }}>
                {iconFn?.(sel ? T.primary : T.charcoal400)}
              </div>
              <span style={{
                fontSize: 14,
                fontWeight: 600,
                color: sel ? T.primaryDark : T.text,
                letterSpacing: '-0.01em',
              }}>
                {config.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
